module.exports = {
    en: {
        request: {
            box1: 'Are you looking for a new car?',
            box2: 'Become our dealer',
            box1txt: "We are committed to providing our customers with outstanding service.",
            box2txt: "Become an official dealer of our cars and stay satisfied with our service!",
            contact: "Send request",
        }
    },
    ka: {
        request: {
           box1: 'ეძებ ახალ მანქანას ? ',
            box2: 'გახდი ჩვენი დილერი',
            box1txt: "ჩვენ მოწადინებულნი ვართ ჩვენს მომხმარებლებს უზრუნველვყოთ გამორჩეული მომსახურება",
            box2txt: "გახდი ჩვენი მანქანების ოფიციალური დილერი დარჩი კმაყოფილი ჩვენი სერვისით !",
            contact: "მოთხოვნის გაგზავნა",
        }
    },
    ru: {
        request: {
            box1: 'Ищете новую машину?',
            box2: 'Станьте нашим дилером',
            box1txt: "Мы стремимся предоставлять нашим клиентам исключительный сервис.",
            box2txt: "Станьте официальным дилером наших автомобилей и останьтесь довольны нашим сервисом!",
            contact: "Отправить запрос",
        }
    }
}